module.exports = __webpack_public_path__ + "static/media/music.f07b01e4.png";